<template>
  <div>
    <search id="searchComponent" class="mb-4" @getFilter="getFilter"></search>


    <div v-if="this.posts.length > 0" class="container d-block d-md-none bg-white p-2 mb-2">
      <div class="row">
        <div class="col-6 text-center pr-0">
          <a class="text-decoration-none" href="#" data-toggle="modal" data-target="#sortModal">
            <i class="fas fa-sort pr-1"></i>Ordenar
          </a>
        </div>
        <div class="col-6 text-center pl-0">
          <a href="#" :class="{
      'text-decoration-none font-weight-bold text-danger': selectedUbicaciones.length > 0 || selectedSubcategorias.length > 0 || selectedMarcas.length > 0 || selectedEstados.length > 0,
      'text-decoration-none text-primary font-weight-normal': selectedUbicaciones.length === 0 && selectedSubcategorias.length === 0 && selectedMarcas.length === 0 && selectedEstados.length === 0
    }" data-toggle="modal" data-target="#filterModal"><i class="fas fa-filter pr-1"></i>Filtrar</a>
        </div>
      </div>
    </div>

    <!-- Modal Ordenar-->
    <div class="modal fade slow-close-modal" id="sortModal" tabindex="-1" aria-labelledby="sortModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="sortModalLabel">Ordenar por:</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="list-group">
              <button type="button" class="list-group-item list-group-item-action" @click="setOrden('desc-date')"
                data-dismiss="modal">Última Actualización</button>
              <button type="button" class="list-group-item list-group-item-action" @click="setOrden('asc-price')"
                data-dismiss="modal">Precio Menor</button>
              <button type="button" class="list-group-item list-group-item-action" @click="setOrden('desc-price')"
                data-dismiss="modal">Precio Mayor</button>
              <button type="button" class="list-group-item list-group-item-action" @click="setOrden('asc-title')"
                data-dismiss="modal">Orden A - Z</button>
              <button type="button" class="list-group-item list-group-item-action" @click="setOrden('desc-title')"
                data-dismiss="modal">Orden Z - A</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Filtrar-->
    <div class="modal fade" id="filterModal" tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="filterModalLabel">Filtrar por:</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="list-group">

              <!-- Ubicación -->
              <button type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                data-toggle="collapse" href="#ubicacionOptions" aria-expanded="false" aria-controls="ubicacionOptions">
                <div class="d-flex flex-grow-1 align-items-center">
                  <span :class="{ 'font-weight-bold': selectedUbicaciones.length > 0 }">Ubicación</span>
                  <span v-if="selectedUbicaciones.length > 0" class="badge badge-primary ml-2">{{
      selectedUbicaciones.length }}</span>
                </div>
                <i class="fas fa-chevron-down"></i>
              </button>
              <div class="collapse" id="ubicacionOptions">
                <div class="list-group">
                  <!-- Lista de ubicaciones con checkbox -->
                  <div class="list-group-item list-group-item-action" v-for="ubicacion in arrayRegion"
                    :key="'u_' + ubicacion.id">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :id="'u_' + ubicacion.id" :value="ubicacion.id"
                        v-model="selectedUbicaciones" @change="getPostFilter()">
                      <label class="form-check-label" :for="ubicacion">{{ ubicacion.nombre }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Categoría -->
              <!-- Botón de categorías -->
              <button type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                data-toggle="collapse" href="#categoriaOptions" aria-expanded="false" aria-controls="categoriaOptions">
                <div class="d-flex flex-grow-1 align-items-center">
                  <span :class="{ 'font-weight-bold': selectedSubcategorias.length > 0 }">Categoría</span>
                  <!-- Mostrar el badge solo si hay subcategorías seleccionadas -->
                  <span v-if="selectedSubcategorias.length > 0" class="badge badge-primary ml-2">{{
      selectedSubcategorias.length }}</span>
                </div>
                <!-- Ícono que cambia al colapsar -->
                <i class="fas fa-chevron-down"></i>
              </button>

              <!-- Contenedor colapsable para categorías -->
              <div class="collapse" id="categoriaOptions">
                <div class="list-group">
                  <!-- Lista de categorías con checkbox -->
                  <div id="accordionCategorias" class="list-group-item list-group-item-action p-1">
                    <div class="card" v-for="(categoria, index) in arrayCategorias" :key="'c_' + categoria">
                      <!-- Botón de categoría -->
                      <div class="card-header" :id="'heading-' + index">
                        <h5 class="mb-0">
                          <button class="btn btn-category d-flex justify-content-between align-items-center text-sm"
                            type="button" data-toggle="collapse" :data-target="'#collapse-' + index"
                            aria-expanded="true" :aria-controls="'collapse-' + index"
                            :class="{ 'font-weight-bold': hasSelectedSubcategorias(categoria) }">
                            <span>{{ categoria }}</span>
                            <!-- Ícono de flecha hacia abajo -->
                            <i class="fas fa-chevron-down"></i>
                          </button>
                        </h5>
                      </div>

                      <!-- Contenido colapsable con subcategorías -->
                      <div :id="'collapse-' + index" class="collapse" :aria-labelledby="'heading-' + index"
                        data-parent="#accordionCategorias">
                        <div class="card-body">
                          <!-- Checkbox de subcategorías -->
                          <div class="form-check" v-for="subcategoria in getSubcategorias(categoria)"
                            :key="'s_' + subcategoria">
                            <input class="form-check-input" type="checkbox" :id="subcategoria" :value="subcategoria"
                              v-model="selectedSubcategorias" @change="getPostFilter()">
                            <label class="form-check-label text-sm" :for="subcategoria">
                              {{ subcategoria }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- Estado -->
              <button type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                data-toggle="collapse" href="#estadoOptions" aria-expanded="false" aria-controls="estadoOptions">
                <div class="d-flex flex-grow-1 align-items-center">
                  <span :class="{ 'font-weight-bold': selectedEstados.length > 0 }">Estado</span>
                  <span v-if="selectedEstados.length > 0" class="badge badge-primary ml-2">{{ selectedEstados.length
                    }}</span>
                </div>
                <i class="fas fa-chevron-down"></i>
              </button>
              <div class="collapse" id="estadoOptions">
                <div class="list-group">
                  <!-- Lista de estados con checkbox -->
                  <div class="list-group-item list-group-item-action" v-for="estado in arrayEstado" :key="'e_' + estado.id">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :id="'e_' + estado.id" :value="estado.id"
                        v-model="selectedEstados" @change="getPostFilter()">
                      <label class="form-check-label" :for="estado">{{ estado.nombre }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Marca -->
              <button v-if="arrayMarcas.length > 0" type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                data-toggle="collapse" href="#marcaOptions" aria-expanded="false" aria-controls="marcaOptions">
                <div class="d-flex flex-grow-1 align-items-center">
                  <span :class="{ 'font-weight-bold': selectedMarcas.length > 0 }">Marca</span>
                  <span v-if="selectedMarcas.length > 0" class="badge badge-primary ml-2">{{ selectedMarcas.length
                    }}</span>
                </div>
                <i class="fas fa-chevron-down"></i>
              </button>
              <div v-if="arrayMarcas.length > 0" class="collapse" id="marcaOptions">
                <div class="list-group">
                  <!-- Lista de marcas con checkbox -->
                  <div class="list-group-item list-group-item-action" v-for="marca in arrayMarcas" :key="'m_' + marca">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :id="'m_' + marca" :value="marca"
                        v-model="selectedMarcas" @change="getPostFilter()">
                      <label class="form-check-label" :for="marca">{{ marca }}</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Columna 1: 2/12 -->
      <div class="col-12 d-none d-md-block col-md-2 pl-0 pr-0">
        <div class="list-group">

          <!-- Ubicación -->
          <div class="card mb-3 border-0">
            <!-- Título de la sección -->
            <div class="d-flex justify-content-between align-items-center">
              <span :class="{ 'font-weight-bold': selectedUbicaciones.length > 0 }">Ubicación</span>
              <span v-if="selectedUbicaciones.length > 0" class="badge badge-primary">{{ selectedUbicaciones.length
                }}</span>
            </div>

            <!-- Lista de ubicaciones con checkbox -->
            <div class="card-body">
              <div class="form-check" v-for="ubicacion in arrayRegion" :key="'ul_' + ubicacion.id">
                <input class="form-check-input" type="checkbox" :id="'u_' + ubicacion.id" :value="ubicacion.id"
                  v-model="selectedUbicaciones" @change="getPostFilter()">
                <label class="form-check-label text-sm" :for="ubicacion">{{ ubicacion.nombre }}</label>
              </div>
            </div>
          </div>

          <!-- Categoría -->
          <div class="card mb-3 border-0">
            <!-- Título de la sección -->
            <div class="d-flex justify-content-between align-items-center">
              <span :class="{ 'font-weight-bold': selectedSubcategorias.length > 0 }">Categoría</span>
              <span v-if="selectedSubcategorias.length > 0" class="badge badge-primary">{{ selectedSubcategorias.length
                }}</span>
            </div>

            <!-- Lista de categorías con checkbox -->
            <div id="accordionCategorias">
              <div class="card border-0" v-for="(categoria, index) in arrayCategorias" :key="'cl_' + categoria">
                <!-- Botón de categoría -->
                <div class="card-header" :id="'heading-' + index">
                  <h5 class="mb-0">
                    <button class="btn btn-category d-flex justify-content-between align-items-center text-sm"
                      type="button" data-toggle="collapse" :data-target="'#collapse-' + index" aria-expanded="true"
                      :aria-controls="'collapse-' + index">
                      <span>{{ categoria }}</span>
                      <!-- Ícono de flecha hacia abajo -->
                      <i class="fas fa-chevron-down"></i>
                    </button>
                  </h5>
                </div>
                <!-- Contenido colapsable con subcategorías -->
                <div :id="'collapse-' + index" class="collapse" :aria-labelledby="'heading-' + index"
                  data-parent="#accordionCategorias">
                  <div class="card-body">
                    <!-- Checkbox de subcategorías -->
                    <div class="form-check" v-for="subcategoria in getSubcategorias(categoria)" :key="'sl_' + subcategoria">
                      <input class="form-check-input" type="checkbox" :id="subcategoria" :value="subcategoria"
                        v-model="selectedSubcategorias" @change="getPostFilter()">
                      <label class="form-check-label text-sm" :for="subcategoria">{{ subcategoria }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Estado -->
          <div class="card mb-3 border-0">
            <div class="d-flex justify-content-between align-items-center">
              <span :class="{ 'font-weight-bold': selectedEstados.length > 0 }">Estado</span>
              <span v-if="selectedEstados.length > 0" class="badge badge-primary">{{ selectedEstados.length }}</span>
            </div>

            <!-- Lista de estados con checkbox -->
            <div class="card-body">
              <div class="form-check" v-for="estado in arrayEstado" :key="'el_' + estado.id">
                <input class="form-check-input" type="checkbox" :id="'e_' + estado.id" :value="estado.id"
                  v-model="selectedEstados" @change="getPostFilter()">
                <label class="form-check-label text-sm" :for="estado">{{ estado.nombre }}</label>
              </div>
            </div>
          </div>


          <!-- Marca -->
          <div v-if="arrayMarcas.length > 0" class="card mb-3 border-0">
            <div class="d-flex justify-content-between align-items-center">
              <span :class="{ 'font-weight-bold': selectedMarcas.length > 0 }">Marca</span>
              <span v-if="selectedMarcas.length > 0" class="badge badge-primary">{{ selectedMarcas.length }}</span>
            </div>

            <!-- Lista de marcas con checkbox -->
            <div class="card-body">
              <div class="form-check" v-for="marca in marcasVisibles" :key="'ml_' + marca">
                <input class="form-check-input" type="checkbox" :id="'m_' + marca" :value="marca" v-model="selectedMarcas" @change="getPostFilter()">
                <label class="form-check-label text-sm" :for="marca">{{ marca }}</label>
              </div>

              <!-- Botón "Ver más" o "Ver menos" -->
              <button type="button" v-if="arrayMarcas.length > 10" class="btn btn-link p-0 mt-2"
                @click="mostrarTodasMarcas = !mostrarTodasMarcas">
                {{ mostrarTodasMarcas ? 'Ver menos' : 'Ver más' }}
              </button>
            </div>
          </div>



        </div>
      </div>

      <!-- Columna 2: 8/12 -->
      <div class="col-12 col-md-9">
        <div v-if="this.posts.length > 0" class="container d-none d-md-block">
          <div class="form-group row col-md-8 offset-md-4">
            <label for="inputState" class="col-5 col-lg-8 col-form-label text-right">Ordenar por:</label>
            <select v-model="orden" @change="cambiarOrden" class="form-control form-control-sm col-7 col-lg-4 my-auto">
              <option value="desc-date">Última Actualización</option>
              <option value="asc-price">Precio Menor</option>
              <option value="desc-price">Precio Mayor</option>
              <option value="asc-title">Orden A - Z</option>
              <option value="desc-title">Orden Z - A</option>
            </select>
          </div>
        </div>

        <post-list-default :key="currentPage" @getCurrentPage="getCurrentPage" v-if="total > 0" :posts="posts"
          :pCurrentPage="currentPage" :total="total" :ruta="ruta">
        </post-list-default>
      </div>

      <!-- Columna 3: 2/12 -->
      <div class="col-12 col-md-1 d-block">
        <!-- Contenido de la tercera columna -->
        <!-- adsense / -->
      </div>
    </div>



  </div>
</template>
<script>
import SearchComponentVue from "./SearchComponent.vue";
export default {
  components: {
    SearchComponentVue
  },
  created() {
    if (localStorage.filtro) {
      this.getFilter(localStorage.filtro);
      this.setArrayFiltros(localStorage.filtro);
    }
    else {
      this.getPosts();
      this.setArrayFiltros('Titulo: ');
    }
    if (this.$route.name == 'lista') {
      this.ruta = '/inicio/list/detalle/';
    }
  },
  computed: {
    // Computed property para mostrar las primeras 10 marcas o todas según la bandera
    marcasVisibles() {
      return this.mostrarTodasMarcas ? this.arrayMarcas : this.arrayMarcas.slice(0, 10);
    },
  },
  methods: {
    cambiarOrden() {
      this.currentPage = 1;
      if (localStorage.filtro) {
        this.getFilter(localStorage.filtro);
      }
      else {
        this.getPosts();
      }
    },
    postClick: function (p) {
      this.postSelected = p;
    },
    getPosts() {
      
      const params = new URLSearchParams();
      params.append('page', this.currentPage);
      params.append('orden', this.orden);
      
      // Añadiendo los filtros seleccionados
      this.selectedSubcategorias.forEach(categoria => params.append('categorias[]', categoria));
      this.selectedUbicaciones.forEach(ubicacion => params.append('ubicaciones[]', ubicacion));
      this.selectedMarcas.forEach(marca => params.append('marcas[]', marca));
      this.selectedEstados.forEach(estado => params.append('estados[]', estado));

      fetch(`/api/post/?${params.toString()}`)
        .then((response) => response.json())
        .then((json) => {
          this.posts = json.data.data;
          //this.setArrayFiltros();
          this.total = json.data.last_page;
        });
    },
    getCurrentPage: function (val) {
      this.currentPage = val;
      if (localStorage.filtro) {
        this.getFilter(localStorage.filtro);
      }
      else {
        this.getPosts();
      }
    },
    pp() {
      //console.log('asasas');
    },
    getFilter(data) {
      if (data == '') {
        data = 'Titulo: ';
      }
      let data_url = 'find';
      const encodedTitulo = encodeURIComponent(data);

      const params = new URLSearchParams();
      params.append('page', this.currentPage);
      params.append('filtro', encodedTitulo);
      params.append('orden', this.orden);
      
      // Añadiendo los filtros seleccionados
      this.selectedSubcategorias.forEach(categoria => params.append('categorias[]', categoria));
      this.selectedUbicaciones.forEach(ubicacion => params.append('ubicaciones[]', ubicacion));
      this.selectedMarcas.forEach(marca => params.append('marcas[]', marca));
      this.selectedEstados.forEach(estado => params.append('estados[]', estado));

      fetch(`/api/post_filter/${data_url}/?${params.toString()}`)
        .then((response) => response.json())
        .then((json) => {
          this.posts = json.data.data;
          //this.setArrayFiltros();
          this.total = json.data.last_page;
        });
    },
    setOrden(orderby) {
      this.orden = orderby;
      this.getPosts();
    },
    setArrayFiltros(data) {
      if (data == '') {
        data = 'Titulo: ';
      }
      const encodedTitulo = encodeURIComponent(data);

      const params = new URLSearchParams();
      params.append('filtro', encodedTitulo);

      fetch(`/api/getFilters/?${params.toString()}`)
        .then((response) => response.json())
        .then((json) => {
          this.arrayFilters = json;

          this.arrayRegion = Object.entries(this.arrayFilters['regiones'])
            .map(([key, value]) => ({ id: key, nombre: value }))
            .filter(item => Boolean(item.nombre)) // Filtrar valores válidos
            .sort((a, b) => a.nombre.localeCompare(b.nombre)); // Ordenar alfabéticamente por nombre

          this.arrayEstado = Object.entries(this.arrayFilters['estados'])
            .map(([key, value]) => ({ id: key, nombre: value }))
            .filter(item => Boolean(item.nombre)) // Filtrar valores válidos
            .sort((a, b) => a.nombre.localeCompare(b.nombre)); // Ordenar alfabéticamente por nombre



          this.arrayMarcas = [...new Set(this.arrayFilters['marcas'].map(item => item).filter(Boolean))].sort();
          this.arrayCategorias = [...new Set(Object.keys(this.arrayFilters['categorias']))].sort();

        });
    },
    isCollapsed(id) {
      const element = document.querySelector(id);
      return element ? element.classList.contains('show') : false;
    },
    getSubcategorias(categoria) {
      return Object.keys(this.arrayFilters['categorias'][categoria]);
    },
    // Devuelve true si alguna subcategoría de la categoría dada está seleccionada
    hasSelectedSubcategorias(categoria) {
      const subcategorias = this.getSubcategorias(categoria);
      return subcategorias.some(subcategoria => this.selectedSubcategorias.includes(subcategoria));
    },
    getPostFilter() {
      let filtro = localStorage.filtro;
      if (filtro == '') {
        filtro = 'Filtros: ';
      }
      let data_url = 'find';
      const encodedTitulo = encodeURIComponent(filtro);

      const params = new URLSearchParams();
      params.append('page', this.currentPage);
      params.append('filtro', encodedTitulo);
      params.append('orden', this.orden);

      // Añadiendo los filtros seleccionados
      this.selectedSubcategorias.forEach(categoria => params.append('categorias[]', categoria));
      this.selectedUbicaciones.forEach(ubicacion => params.append('ubicaciones[]', ubicacion));
      this.selectedMarcas.forEach(marca => params.append('marcas[]', marca));
      this.selectedEstados.forEach(estado => params.append('estados[]', estado));

      fetch(`/api/post_filter_list/${data_url}/?${params.toString()}`)
        .then((response) => response.json())
        .then((json) => {
          this.posts = json.data.data;
          //this.setArrayFiltros();
          this.total = json.data.last_page;
        });
    },
  },
  data: function () {
    return {
      orden: 'default',
      postSelected: "",
      posts: [],
      total: 0,
      currentPage: 1,
      ruta: '/list/detail/',
      filter: localStorage.filtro,
      arrayRegion: [],
      arrayEstado: [],
      arrayMarcas: [],
      arrayCategorias: [],
      arrayFilters: [],
      selectedCategorias: [],
      selectedSubcategorias: [],
      selectedUbicaciones: [],
      selectedEstados: [],
      selectedMarcas: [],
      mostrarTodasMarcas: false,
    };
  },
};
</script>
<style>
/* Clase personalizada para cambiar la velocidad de la animación */
.slow-close-modal .modal-dialog {
  transition: transform 0.7s ease-out, opacity 0.7s ease-out;
}

.font-weight-bold {
  font-weight: bold;
}

.card-body {
  padding: 0.7rem !important;
}

.text-sm {
  font-size: 0.8rem;
}

.btn-category {
  background-color: transparent;
  border: none !important;
  outline: none;
  padding: 0;
  width: 100%;
  text-align: left;
  /* font-size: 1rem; */
  font-weight: normal;
  color: inherit;
  /* Mantiene el color de texto por defecto */
}

.btn-category:focus {
  box-shadow: none;
  /* Elimina el efecto de enfoque de Bootstrap */
}

.btn-category:hover {
  background-color: transparent;
  /* Desactiva el color de fondo en hover */
}

.card-header {
  background-color: transparent;
  border: none;
}

.card {
  word-wrap: normal;
}

.container {
  padding-left: 5px !important;
}
</style>